import { pinia } from 'www/plugins'
import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import { initI18n } from 'www/utils'
import LpuServices from 'www/vue_components/common/LpuServices/components/LpuServices.vue'
import { MOUNT_SELECTOR } from 'www/vue_components/common/LpuServices/constants'
import { addListenerShowAllButton } from 'www/vue_components/common/LpuServices/functions'

const mountComponent = async () => {
  await initI18n({ bundle: 'vue_components/common/LpuServices' })

  const mountElement = document.querySelector(MOUNT_SELECTOR)

  if (mountElement) {
    new Vue({
      vuetify,
      el: mountElement,
      pinia,
      components: {
        LpuServices,
      },
    })
  }
}

mountComponent()
addListenerShowAllButton()
